import { brandImageFromService, brandColorsFromService, brandInsightFromService } from "./brand";
import { creativeBriefFromService } from "./creative";
import { audienceSegmentsFromService } from "./audience";
import { geoTargetingFromService } from "./geo";
import { advertiserProfileFromService } from "./advertiser";
import { reviewDataFromService } from "./reviews";
export * from "./brand";
export * from "./creative";
export * from "./audience";
export * from "./geo";
export * from "./advertiser";
export * from "./reviews";
export * from "./generateJobs";
export const googlePlaceFromService = (place) => ({
    // place_id/name are optional on the generated type (spec-wide conservatism),
    // but services/creative's search always returns both for a real result.
    placeId: place.place_id ?? "",
    name: place.name ?? "",
    ...(place.address !== undefined && { address: place.address }),
    ...(place.category !== undefined && { category: place.category }),
    ...(place.website !== undefined && { website: place.website }),
    ...(place.phone !== undefined && { phone: place.phone }),
    ...(place.rating !== undefined && { rating: place.rating }),
    ...(place.photo_ref !== undefined && { photoRef: place.photo_ref })
});
export const googlePlaceToService = (place) => ({
    place_id: place.placeId,
    name: place.name,
    ...(place.address !== undefined && { address: place.address }),
    ...(place.category !== undefined && { category: place.category }),
    ...(place.website !== undefined && { website: place.website }),
    ...(place.phone !== undefined && { phone: place.phone }),
    ...(place.rating !== undefined && { rating: place.rating }),
    ...(place.photoRef !== undefined && { photo_ref: place.photoRef })
});
export const analyzeBrandDataFromService = (data) => ({
    ...(data.brand_name && { brandName: data.brand_name }),
    images: data.images ? data.images.map(brandImageFromService) : null,
    colors: brandColorsFromService(data.colors),
    fonts: data.fonts,
    ...(data.brand_summary?.tagline && { tagline: data.brand_summary.tagline }),
    ...(data.brand_personality?.adjectives && { personality: data.brand_personality.adjectives }),
    ...(data.creative_brief && { creativeBrief: creativeBriefFromService(data.creative_brief) }),
    ...("brand_insights" in data && {
        brandInsights: data.brand_insights ? data.brand_insights.map(brandInsightFromService) : null
    }),
    ...(data.audience_segments && {
        audienceSegments: audienceSegmentsFromService(data.audience_segments)
    }),
    ...(data.geo_targeting && { geoTargeting: geoTargetingFromService(data.geo_targeting) }),
    ...(data.advertiser_profile && {
        advertiserProfile: advertiserProfileFromService(data.advertiser_profile)
    }),
    ...(data.review_data && { reviewData: reviewDataFromService(data.review_data) })
});
export const creativeJobAssetFromService = (asset) => ({
    // url/size are always present on the wire, same conservatism/fallback
    // pattern as googlePlaceFromService above.
    url: asset.url ?? "",
    size: asset.size ?? "",
    // Passed to AiCreative.assets.download() for an authenticated download,
    // bypassing the signed URL's CORS restriction.
    ...("gcs_key" in asset && { gcsKey: asset.gcs_key })
});
export const creativeJobVariantFromService = (variant) => ({
    // Always present (never conditionally spread) so a consumer's fallback
    // chain (e.g. variantKey's index fallback) can tell "absent" from "empty
    // string" consistently with generateJobs.ts's creativeVariantFromService,
    // which uses the same `?? ""` pattern for this field.
    styleVariant: variant.style_variant ?? "",
    ...("style_name" in variant && { styleName: variant.style_name }),
    headlines: variant.headlines ?? [],
    ...("tagline" in variant && { tagline: variant.tagline }),
    ...("cta_text" in variant && { ctaText: variant.cta_text }),
    // Why this concept was selected/generated — shown in the variants modal.
    ...("selection_reason" in variant && { selectionReason: variant.selection_reason }),
    assets: (variant.assets ?? []).map(creativeJobAssetFromService)
});
export const creativeJobFromService = (job) => ({
    // job_id/brand_slug/brand_name/advertiser_url/goal are always present on
    // the wire, same conservatism/fallback pattern as googlePlaceFromService.
    jobId: job.job_id ?? "",
    brandSlug: job.brand_slug ?? "",
    brandName: job.brand_name ?? "",
    advertiserUrl: job.advertiser_url ?? "",
    goal: job.goal ?? "",
    // username is set at job creation and never updated — it identifies the requester.
    requestedBy: job.username ?? "",
    sizes: job.sizes ?? [],
    ...(job.created_at && { createdAt: new Date(job.created_at) }),
    status: job.status ?? "",
    variants: (job.variants ?? []).map(creativeJobVariantFromService)
});
//# sourceMappingURL=index.js.map